import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ButtonToolbar, Well } from '@sketchpixy/rubix'
import {NotificationManager} from 'react-notifications'
import { FlatButton, Dialog } from 'material-ui'
import Page from '../common/Page/Page'
import {FETCH_SUPERVISOR_EVENTS_REQUEST, SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_REQUEST} from '../../actions/actions'
import {
  goToEventStudents,
  goToEventSchools,
  goToEventHosts,
  goToEventCouponCodes,
  goToUploadEventDocuments,
} from './helpers'
import * as R from 'ramda'
import * as MabnaButton from '../common/Button/Button'
import { promised } from '../../helpers/utility';

class SupervisorEventPages extends Component {
  constructor(props) {
    super(props)

    this.state = {
      finishHostingOpen: false,
    }
  }

  componentDidMount() {
    if(R.isEmpty(this.props.events)) {
      this.fetchEvents()
    }
  }

  fetchEvents = () => {
    return this.props.dispatch({
      type: FETCH_SUPERVISOR_EVENTS_REQUEST
    })
  }

  render() {
    const {
      selectedEvent,
      params: {
        eventId,
      }
    } = this.props

    const finishHostingActionButtons = [
      <FlatButton
        label="انصراف"
        primary={false}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="تایید"
        primary={true}
        onTouchTap={this.confirmFinishHosting}
      />,
    ]

    return (
      <div>
        <Well>
          <ButtonToolbar>
            <span>
              رویداد: {selectedEvent && selectedEvent.title}
            </span>

            {!selectedEvent? null : (
              selectedEvent.finished_hosts_setup ? (
                <div>
                  <MabnaButton.Primary
                    href={selectedEvent.hosting_excel_report}
                    target='_blank'
                    download
                  >
                    گزارش
                  </MabnaButton.Primary>
                  <MabnaButton.Primary onClick={() => goToUploadEventDocuments(eventId)}>
                    آپلود مدارک
                  </MabnaButton.Primary>
                </div>
              ) : (
                <div>
                  <MabnaButton.Primary onClick={() => goToEventSchools(eventId)}>
                    مدارس
                  </MabnaButton.Primary>
                  <MabnaButton.Primary onClick={() => goToEventStudents(eventId, { register_type: 'single' })}>
                    انفرادی
                  </MabnaButton.Primary>
                  <MabnaButton.Primary onClick={() => goToEventStudents(eventId)}>
                    بدون حوزه
                  </MabnaButton.Primary>
                  <MabnaButton.Primary onClick={() => goToEventHosts(eventId)}>
                    حوزه‌ها
                  </MabnaButton.Primary>
                  <MabnaButton.Primary onClick={() => goToEventCouponCodes(eventId)}>
                    کدهای تخفیف
                  </MabnaButton.Primary>

                  <MabnaButton.Warning onClick={this.handleOpen}>
                    پایان حوزه‌بندی
                  </MabnaButton.Warning>
                </div>
              )
            )}

          </ButtonToolbar>

        </Well>

        <Page className='manager-pages'>
          {this.props.children}
        </Page>

        <Dialog
          title='پایان حوزه‌بندی'
          open={this.state.finishHostingOpen}
          actions={finishHostingActionButtons}
          modal={false}
          onRequestClose={this.handleClose}
        >
          پس از پایان حوزه‌بندی امکان تغییر اطلاعات وجود ندارد!
          <br/>
          آیا از پایان حوزه‌بندی اطمینان دارید؟
        </Dialog>
      </div>
    )
  }

  handleOpen = () => {
    this.setState({
      finishHostingOpen: true,
    })
  }

  handleClose = () => {
    this.setState({
      finishHostingOpen: false,
    })
  }

  confirmFinishHosting = () => {
    this.handleClose()

    return promised(this.dispatchConfirmFinishHosting)
      .then(this.confirmFinishHostingSuccess)
      .catch(this.confirmFinishHostingFailure)
  }

  confirmFinishHostingSuccess = res => {
    NotificationManager.success('حوزه‌بندی با موفقیت پایان یافت.')
    this.fetchEvents()
  }

  confirmFinishHostingFailure = res => {
    for (let key in res) {
      if (res.hasOwnProperty(key)) {
        NotificationManager.error(res[key])
      }
    }
  }

  dispatchConfirmFinishHosting = ({resolve, reject}) => {
    return this.props.dispatch({
      type: SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_REQUEST,
      eventId: this.props.params.eventId,
      resolve,
      reject,
    })
  }
}

function mapStateToProps(state, ownProps) {
  const eventId = ownProps.params && ownProps.params.eventId
  const eventsRoot = state.supervisorReducers.events
  const events = eventsRoot && eventsRoot.data && eventsRoot.data.events
  const selectedEvent = events && R.find(R.propEq('id', parseInt(eventId)))(events)

  return {
    events: state.supervisorReducers.events,
    selectedEvent,
  }
}

export default connect(
  mapStateToProps,
)(SupervisorEventPages)


// WEBPACK FOOTER //
// ./src/components/supervisor/Index.js